import "./header.css";
import { NavLink, Link } from "react-router-dom";
import { socialMediaLinks } from "../../data/socialMediaLinks";

export function Header() {
    const navItems = [
        { displayName: "Home", link: "/" },
        { displayName: "Project", link: "/project" },
        { displayName: "Blog", link: "/blog" },
    ];

    return (
        <header className="bg-primary text-white relative">
            <div className="flex flex-col gap-8 items-center py-1 ml-auto">
                <Link
                    to="/"
                    className="text-3xl pt-4 hover:cursor-pointer hover:opacity-80"
                >
                    Parth Gabani
                </Link>
                <nav className="text-base flex gap-5 pb-3">
                    {navItems.map((navItem) => (
                        <NavLink
                            to={navItem.link}
                            key={navItem.displayName}
                            className={({ isActive }) =>
                                [
                                    "hover:opacity-80",
                                    isActive
                                        ? "underline decoration-secondary decoration-4 underline-offset-4"
                                        : null,
                                ]
                                    .filter(Boolean)
                                    .join(" ")
                            }
                        >
                            {navItem.displayName}
                        </NavLink>
                    ))}
                </nav>
            </div>
            <div className="text-2xl flex gap-5 absolute right-0 top-0 h-full justify-center items-center pr-5">
                {socialMediaLinks.map((socialMedia) => (
                    <a
                        href={socialMedia.url}
                        className="hover:opacity-80"
                        key={socialMedia.icons}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {socialMedia.iconURL ? (
                            <img
                                src={socialMedia.iconURL}
                                alt="social"
                                className="h-[24px]"
                            />
                        ) : (
                            <i className={`fab ${socialMedia.icons}`}></i>
                        )}
                    </a>
                ))}
            </div>
        </header>
    );
}
